export enum AuthVia {
  MedmasteryApp = 'medmastery-app',
}

export enum AuthViaStorageKey {
  AuthVia = 'mm_auth_via',
  IsNewSignup = 'mm_is_new_signup',
  Platform = 'mm_platform',
}

export type UserRole = 'member' | 'professional' | 'Group manager' | 'Group owner' | 'Group member';

export enum SubscriptionType {
  trial = 'trial',
  basic = 'basic',
  pro = 'pro',
}

export enum SubscriptionPurchasePlatform {
  WEB = 'web',
  APPLE = 'apple',
  GOOGLE = 'google',
}
